import { Paper, Typography } from "@material-ui/core";
import useStyles from "./grupoPanelStyles";

const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const GrupoPanel = ({ grupo, inicioVigencia, grupoInfo }) => {
  const classes = useStyles();
  return (
    <Paper elevation={3} className={classes.panel}>
      <Typography variant="h6" className={classes.title}>
        Datos del grupo
      </Typography>
      <div className={classes.field}>
        <Typography className={classes.value}>{grupo}</Typography>
        <Typography className={classes.label}>Grupo</Typography>
      </div>
      <div className={classes.field}>
        <Typography className={classes.value}>
          {grupoInfo.contratante}
        </Typography>
        <Typography className={classes.label}>Contratante</Typography>
      </div>
      <div className={classes.fila}>
        <div className={classes.field}>
          <Typography className={classes.value}>
            {inicioVigencia || formatDate(grupoInfo.fechaInicio)}
          </Typography>
          <Typography className={classes.label}>Inicio de Vigencia</Typography>
        </div>
        <div className={classes.field}>
          <Typography className={classes.value}>
            {formatDate(grupoInfo.fechaFin)}
          </Typography>
          <Typography className={classes.label}>Fin de Vigencia</Typography>
        </div>
      </div>
    </Paper>
  );
};

export default GrupoPanel;
